import React from 'react';
import { useNavigate } from 'react-router-dom';
import Settings from './Components/Settings';
import SidebarPageLayout from './SidebarPageLayout';

function ProfileSettingsPage() {
  const navigate = useNavigate();

  return (
    <SidebarPageLayout>
      <Settings
        open
        asPage
        onClose={() => navigate('/home')}
      />
    </SidebarPageLayout>
  );
}

export default ProfileSettingsPage;
